module.exports = __webpack_public_path__ + "static/media/VPM_desktop_4.3ca3c5ad.jpg";